import { Mark } from "@tiptap/core";
import { isSafeHref, toSafeHref } from "../inline.ts";

// Every mark excludes all marks ("_"): a text run carries at most one mark (contract C3).

export const Bold = Mark.create({
  name: "bold",
  excludes: "_",
  // Google Docs wraps a whole paste in <b style="font-weight:normal">: only a real bold <b> counts.
  parseHTML: () => [
    { tag: "strong" },
    { tag: "b", getAttrs: (el) => (/^(normal|[1-4]00)$/.test((el as HTMLElement).style.fontWeight) ? false : null) },
  ],
  renderHTML: ({ HTMLAttributes }) => ["strong", HTMLAttributes, 0],
});

export const Italic = Mark.create({
  name: "italic",
  excludes: "_",
  parseHTML: () => [{ tag: "em" }, { tag: "i" }],
  renderHTML: ({ HTMLAttributes }) => ["em", HTMLAttributes, 0],
});

export const Code = Mark.create({
  name: "code",
  excludes: "_",
  code: true,
  parseHTML: () => [{ tag: "code" }],
  renderHTML: ({ HTMLAttributes }) => ["code", HTMLAttributes, 0],
});

export const Link = Mark.create({
  name: "link",
  excludes: "_",
  inclusive: false,
  addAttributes: () => ({
    // Pasted hrefs are repaired (scheme lowercased, unsafe characters percent-encoded); others drop the link.
    href: { default: null, parseHTML: (el) => toSafeHref(el.getAttribute("href") ?? "") },
  }),
  parseHTML: () => [{ tag: "a[href]", getAttrs: (el) => (toSafeHref(el.getAttribute("href") ?? "") ? null : false) }],
  // Defence in depth: an unsafe href that reached the document is never rendered.
  renderHTML: ({ HTMLAttributes }) => {
    const { href, ...rest } = HTMLAttributes;
    const safe = typeof href === "string" && isSafeHref(href) ? { href } : {};
    return ["a", { ...rest, ...safe, rel: "noopener noreferrer nofollow" }, 0];
  },
});
